import { useEffect, useState } from 'react';
import { PageDetail, CircleLoader } from 'components';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import * as yup from 'yup';
import { Formik } from 'formik';
import DealerDetailForm from './components';
import { useLocation, useParams, useHistory } from 'react-router';

export let dealerSchema = yup.object().shape({
    dealerId: yup.string().nullable(),
    name: yup.string().default('').required().label('Name'),
    address: yup.string().default('').label('Address'),
    city: yup.string().default('').label('City'),
    zipCode: yup.string().default('').label('Zip Code'),
    phone: yup.string().default(''),
    fax: yup.string().default(''),
    email: yup.string().default('').label('Email'),
    website: yup.string().default(''),
    productLines: yup.string().default(''),
    contactName: yup.string().default(''),
    country: yup.string().default('').required().label('Country'),
    countyCode: yup.string().default(''),
    countyDesc: yup.string().default(''),
    lat: yup.number().default(0),
    lng: yup.number().default(0),
    brands: yup.array(yup.string()).min(1, "At least one brand must be specified").default([]),
    programs: yup.array(yup.string()).default([]),
    markets: yup.array(yup.string()).default([]),
    isDealer: yup.boolean().default(false).label("IsDealer"),
    isDistributor: yup.boolean().default(false).label("IsDistributor"),
})

let DealerDetail = () => {
    let { enqueueSnackbar } = useSnackbar();
    let location = useLocation();
    let { id } = useParams<{ id: string }>();
    let history = useHistory();

    let isNew = location.pathname.includes('/addnew');
    let pageTitle = isNew ? 'New dealer' : 'Edit dealer';

    let [isLoading, setLoading] = useState(isNew === false);
    let [isSaving, setSaving] = useState(false);

    

    type Dealer = yup.InferType<typeof dealerSchema>;

    useEffect(() => {
        if (id)
            getDealer(id);
    }, [id])

    let [dealer, setDealer] = useState<Dealer>(dealerSchema.getDefault());

    let getDealer = async (id: string) => {
        try {
            let res = await axios.get('/api/Dealer/GetDealer', { params: { dealerId: id } });
            setDealer(res.data.item);
        } catch (err) {
            enqueueSnackbar("Unable to get dealer", { variant: 'error' });
        } finally {
            setLoading(false);
        }
    }


    let saveDealer = async (dealer: Dealer) => {
        try {
            setSaving(true);
            await axios.post('/api/Dealer/SaveDealer', dealer)
            history.push('/dealers');
        } catch (err) { }
        finally {
            setSaving(false);
        }
    }


    return (
        <PageDetail title={pageTitle}>
            <Formik
                enableReinitialize={true}
                initialValues={dealer}
                validationSchema={dealerSchema}
                onSubmit={(values, action) => {
                    saveDealer(values);
                    action.setSubmitting(false);
                }}
            >
                {form =>
                    <>
                        {isLoading && <CircleLoader />}
                        {isLoading === false && <DealerDetailForm isSaving={isSaving} form={form} />}
                    </>
                }
            </Formik>
        </PageDetail>
    );
}

export default DealerDetail;